// 서버 shippingTracker.js의 CARRIERS 목록과 동일하게 유지해야 한다
export const CARRIERS = [
  { code: '04', label: 'CJ대한통운' },
  { code: '05', label: '한진택배' },
  { code: '08', label: '롯데택배' },
  { code: '01', label: '우체국택배' },
  { code: '06', label: '로젠택배' },
] as const;

export function carrierLabel(code: string | null | undefined): string {
  return CARRIERS.find((c) => c.code === code)?.label ?? code ?? '-';
}
